// Lockout rules per 11-SECURITY-OPS.md §2 / Brief §4.
//
// Per-device: 5 failed PIN attempts within 5 minutes freezes the device
//   (manager unlocks).
// Per-staff: 10 failed PIN attempts within 1 hour freezes the staff
//   member on every device (manager unlocks).
//
// Pure math. The caller holds the attempt history (DB rows); this
// function just counts them against the window. Attempts should be
// sorted but we don't rely on sort order — a filter + length check is
// O(n) either way.

export type LockoutInput = {
  failedAttempts: ReadonlyArray<Date>;
  now: Date;
};

const DEVICE_WINDOW_MS = 5 * 60_000;
const DEVICE_LIMIT = 5;
const STAFF_WINDOW_MS = 60 * 60_000;
const STAFF_LIMIT = 10;

function countInWindow(attempts: ReadonlyArray<Date>, now: Date, windowMs: number): number {
  const threshold = now.getTime() - windowMs;
  let count = 0;
  for (const attempt of attempts) {
    if (attempt.getTime() > threshold) count++;
  }
  return count;
}

export function isDeviceLocked({ failedAttempts, now }: LockoutInput): boolean {
  return countInWindow(failedAttempts, now, DEVICE_WINDOW_MS) >= DEVICE_LIMIT;
}

export function isStaffLocked({ failedAttempts, now }: LockoutInput): boolean {
  return countInWindow(failedAttempts, now, STAFF_WINDOW_MS) >= STAFF_LIMIT;
}

// Exported constants let the API error messages / UI copy stay in sync.
export const LOCKOUT_RULES = Object.freeze({
  deviceWindowMs: DEVICE_WINDOW_MS,
  deviceLimit: DEVICE_LIMIT,
  staffWindowMs: STAFF_WINDOW_MS,
  staffLimit: STAFF_LIMIT,
});
